export * from './validacao-expediente-cartorio.service';
